import { render, staticRenderFns } from "./IconChapterSmall.vue?vue&type=template&id=63ffbc00&"
import script from "./IconChapterSmall.vue?vue&type=script&lang=js&"
export * from "./IconChapterSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ffbc00')) {
      api.createRecord('63ffbc00', component.options)
    } else {
      api.reload('63ffbc00', component.options)
    }
    module.hot.accept("./IconChapterSmall.vue?vue&type=template&id=63ffbc00&", function () {
      api.rerender('63ffbc00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconChapterSmall.vue"
export default component.exports